<ng-container [cdkPortalOutlet]="templatePortal"></ng-container>
<div class="arrow" popoverArrow></div>
<div class="arrow shadow" popoverArrow></div>
